<template>
    <yandex-map :settings="settings" :coords="[building.map.latitude, building.map.longitude]" :zoom="15"
                :controls="[]"
                @map-was-initialized="initHandler"
                style="width: 100%; height:400px"

    >

        <ymap-marker
                :icon="{
                    layout: 'default#image',
                    imageHref: '/assets/site/images/markers/marker-' + building.status_color + '.svg',
                    imageSize: [20, 20],
                    imageOffset: [0, 0],
                    }"
                :coords="[building.map.latitude, building.map.longitude]"
                :marker-id="building.id"
                marker-type="placemark">

            <balloon slot="balloon" :building="building" ></balloon>
        </ymap-marker>
    </yandex-map>

</template>
<script>
    import balloon from "../building/map-list/balloon";
    import { yandexMap, ymapMarker } from 'vue-yandex-maps';
    export default {
        components: {
            yandexMap, ymapMarker, balloon
        },
        props:{
            building: {
                type: Object,
            }
        },
        data() {
            return {
                settings:{
                    apiKey: 'fbdcc52a-7ad9-4d51-bf5e-7c2cfcf1d3e2',
                    lang: 'ru_RU',
                    version: '2.1'
                },

            }
        },
        methods: {
            initHandler: function(map) {


                // Создадим пользовательский макет ползунка масштаба.
                const ZoomLayout =  ymaps.templateLayoutFactory.createClass("<div class='buildings-map__zoom-controls'>" +
                    "<div id='zoom-in' class='buildings-map__btn'><i class='fas fa-plus'></i></div>" +
                    "<div id='zoom-out' class='buildings-map__btn'><i class='fas fa-minus'></i></div>" +
                    "</div>", {

                    // Переопределяем методы макета, чтобы выполнять дополнительные действия
                    // при построении и очистке макета.
                    build: function () {
                        // Вызываем родительский метод build.
                        ZoomLayout.superclass.build.call(this);

                        // Привязываем функции-обработчики к контексту и сохраняем ссылки
                        // на них, чтобы потом отписаться от событий.
                        this.zoomInCallback = ymaps.util.bind(this.zoomIn, this);
                        this.zoomOutCallback = ymaps.util.bind(this.zoomOut, this);

                        // Начинаем слушать клики на кнопках макета.
                        $('#zoom-in').bind('click', this.zoomInCallback);
                        $('#zoom-out').bind('click', this.zoomOutCallback);
                    },

                    clear: function () {
                        // Снимаем обработчики кликов.
                        $('#zoom-in').unbind('click', this.zoomInCallback);
                        $('#zoom-out').unbind('click', this.zoomOutCallback);

                        // Вызываем родительский метод clear.
                        ZoomLayout.superclass.clear.call(this);
                    },

                    zoomIn: function () {
                        var map = this.getData().control.getMap();
                        map.setZoom(map.getZoom() + 1, {checkZoomRange: true});
                    },

                    zoomOut: function () {
                        var map = this.getData().control.getMap();
                        map.setZoom(map.getZoom() - 1, {checkZoomRange: true});
                    }
                });
                const zoomControl = new ymaps.control.ZoomControl({options: {layout: ZoomLayout}});
                map.controls.add(zoomControl);
            },
        }
    }

</script>
